module.exports = __webpack_public_path__ + "static/plp-b85d02286c2dd14ddf6f83af122effee.jpg";